// src/Pages/Projects/projectsData.ts

import { ankura, palatium, skymarq, vamsiram } from "../../../../assets";

// import { Services } from '../../../../assets';

export interface ProjectData {
  title: string;
  image: string;
  sqft: string;
  isReverse?: boolean;
  link?: string;
  location?: string;
  bhk?: string;
  rera?: string;
  units?: string;
  highlights?: string[];
  status?: string;
}

export const projectsData: ProjectData[] = [
  {
    title: 'Acasa',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/acasa.png',
    sqft: '3520 - 3750 sqft',
    location: 'kokapet, Hyderabad ',
    bhk: '4 BHK',
    rera: 'P02400006471',
    units: '102 units',
    highlights: [
      'True-North Oriented Residences: Designed for balance, light, and positive living',
      'Private Sky Verandas: Personal outdoor sanctuaries with open views',
      'Low-Density Living: Only three exclusive homes per floor',
    ],
    status: 'Active',
    link: '/projects/acasasimchah',
  },
   {
    title: 'Amaris',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/amaris.png',
    sqft: '6228  - 9495 sqft',
    location: 'Financial District, Hyderabad ',
    bhk: '4 BHK',
    rera: 'P02400009940',
    units: '194 units',
    highlights: [
      'Expansive 4 BHK homes with 6000+ sq.ft. layouts',
      'Premium architecture with modern design aesthetics',
      'High-end amenities with curated lifestyle features',
    ],
    status: 'Active',
    link: '/projects/amaris',
  },
  {
    title: 'Promenade Villas',
    image: 'https://dprstorage.b-cdn.net/RW/projects/promenade.png',
    sqft: '3995 - 4207 sqft',
    location: 'Kollur, Hyderabad ',
    bhk: '4 BHK',
    rera: 'P01100003619',
    units: '121 units',
    highlights: [
      'Architectural Brilliance: Bask in the grandeur of double-height living spaces, thoughtfully designed to exude openness and luxury',
      'Breathtaking Outdoor Spaces: Relax and entertain on spacious terraces and elegant balconies',
      'perfect for soaking in serene views',
    ],
    status: 'Active',
    link: '/projects/promenadevillas',
  },
  {
    title: 'Aparna One',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/aparna.png',
    sqft: '2876 - 5216 sqft',
    location: 'Shaikpet, Hyderabad ',
    bhk: '3 & 4 BHK',
    rera: 'P02500000269',
    units: '462 units',
    highlights: [
      'Centrally Located Near Banjara Hills, Jubilee Hills, HITEC City, & Gachibowli',
      'Minutes from Top Schools, Hospitals, IT Parks, & More',
      '40+ Premium Amenities, State-of-the-Art Clubhouse & 80% Open Space',
      'Offers Grand Views of the Golconda Fort, Hyderabad Golf Club, & Qutb Shahi Tombs',
    ],
    status: 'Active',
    link: '/projects/aparna-one',
  },
  {
    title: 'Niche ',
    // image: 'https://dprstorage.b-cdn.net/RW/projects/vh.png',
    image: vamsiram,
    sqft: '3666 - 3942 sqft',
    location: 'Shaikpet, Hyderabad ',
    bhk: '4 BHK',
    units: '96 Units',
    highlights: [
      'Large-format 4 BHK residences designed for luxury living',
      'Low-density community: only 96 homes across 2 acres',
      ' Private lifestyle amenities including clubhouse, fitness & leisure zones',
      ' Seamless access to major schools, hospitals & business hubs in West Hyderabad',

    ],
    status: 'Active',
    link: '/projects/niche-by-vamsiram-homes',
  },

  {
    title: 'Palatium',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/palatium.png',
    sqft: '3,200 sqft',
    location: 'TSPA / APPA Junction, Hyderabad',
    bhk: '3 BHK',
    units: '5 Units',
    highlights: [
      'Villa-style comfort with apartment convenience',
      'Zero shared walls = complete privacy',
      'Servant quarters with private access & bell',
      'EV charging for car & bike',
      'Walk-in wardrobe and spa-style bath in master suite',
      'Smart ventilation and natural lighting across rooms',
      'Low-maintenance design with no crowded common areas',
    ],
    status: 'Ready for Interiors',
    link: '/projects/palatium',
  },

  {
    title: 'Rainbow Waters',
    image: "https://dprstorage.b-cdn.net/RW/newprojects/rainbow%20waters.png",
    sqft: '4955  - 7757  sqft',
    location: 'Raidurg - Gachibowli, Hyderabad -',
    bhk: '2, 3 & 4 BHK',
    rera: 'P02400009910',
    units: '2700 Units',
    highlights: [
      'Luxury residential enclave',
      'Resort-style amenities',
      'Green landscapes',
      'Premium specifications',
    ],
    status: 'Under construction',
    link: '/projects/prestige-vaishnaoi-rainbow-waters',
  },

  {
    title: 'Megaleio',
    image: 'https://dprstorage.b-cdn.net/RW/Megaleio.png',
    sqft: '8,888 - 11,111 sqft',
    location: 'TGSPA Junction , Hyderabad',
    bhk: '4 & 5 BHK',
    rera: 'P02400007676',
    units: '150 Units',
    highlights: [
      'Twin high-rise towers',
      'Premium luxury specifications',
      'Smart automation features',
      'Contemporary architecture',
    ],
    status: 'Under construction',
    link: '/projects/megaleio',
  },
  {
    title: 'Villa Verde',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/villa%20varde.png',
    sqft: '5369- 20464 sq.ft',
    location: 'GREEN HILLS ROAD - HITEC CITY',
    bhk: '4/5/7 BHK Villas',
    rera: 'P02200009074',
    units: '89 Units',
    highlights: [
      'Estate-style villas with private courtyards & pools (select)',
      'Imported marble, premium fittings & walk-in wardrobes',
      'Grand double-height living areas with large glazing',
      'Clubhouse with fine-dining lounge & boutique wellness',
    ],
    status: '',
    link: '/projects/villaverde',
  },
  {
    title: 'MSN ONE',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/msn.png',
    sqft: '5250 - 7460 sq.ft',
    location: 'Neopolis, Hyderabad',
    bhk: '4 BHK Uber Luxury',
    rera: '',
    units: '655 Units',
    highlights: [
      'Uber-luxury residences with premium marble & fixtures',
      'Grand lobby, valet-style entry & concierge desk',
      'Signature clubhouse with spa, indoor courts & café',
      'Smart community with app-based visitor & amenity booking',
    ],
    status: '',
    link: '/projects/msn-one',
  },
  {
    title: 'Skymarq',
    image: "https://dprstorage.b-cdn.net/RW/newprojects/skymarq.png",
    sqft: '3999 - 5454 sq.ft',
    location: ' Narsingi, Financial district,Hyderabad',
    bhk: '3 & 4 BHK',
    rera: '',
    units: '664 Units',
    highlights: [
      'High-floor residences with expansive city views',
      'Double-height entrance lobby & private drop-offs',
      'Curated luxury clubhouse with indoor sports & studios',
      'Smart-home automation with app-based controls',
    ],
    status: '',
    link: '/projects/skymarq',
  },
  {
    title: 'CINQ',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/cinq.png',
    sqft: '3575- 3644 sq.ft',
    location: 'Financial District, Hyderabad',
    bhk: '4 BHK',
    rera: 'P02400009341',
    units: ' 1132 Units',
    // highlights: [],
    highlights: [
      'Master-planned community with multiple podium gardens',
      'Private lift lobbies for select residences',
      'Resort-style pool, spa, and wellness suites',
      'Co-working lounges and themed kids’ play zones',
    ],
    status: '',
    link: '/projects/cinq',
  },
  {
    title: 'Sylvanor',
    image: 'https://dprstorage.b-cdn.net/RW/projects/SYLVANOR.png',
    sqft: '8,249-13,779 sq.ft',
    location: ' Mokila, Hyderabad',
    bhk: '5',
    rera: '',
    units: '147 Villas',
    highlights: [
      'Nature-forward masterplan with tree-lined streets',
      'Private decks & large glazing for natural light',
      'Clubhouse with pool, multi-purpose hall & fitness',
      'Sustainable design with rainwater harvesting & solar',
    ],
    status: '',
    link: '/projects/sylvanor-by-bluefin',
  },
  {
    title: 'Iris',
    image: 'https://dprstorage.b-cdn.net/RW/raghava.png',
    sqft: '5,430 – 6,605 sq.ft.',
    location: 'Raidurgam, Hyderabad',
    bhk: '4 & 6 BHK',
    rera: 'P02400006708',
    units: ' 528 units',
    highlights: [
      '3 iconic towers with 45 floors each',
      'Sky Island” at the top (inspired by Marina Bay, Singapore)',
      'Private elevators for each unit',
      '52,000 sq.ft. clubhouse with theater, spa, infinity pool',
    ],
    status: 'Under construction',
    link: '/projects/iris',
  },
  {
    title: 'Trilight',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/trilight.png',
    sqft: '2888 - 11333 sq.ft',
    location: 'Golden mile, Kokapet, Hyderabad',
    bhk: '3/4 & 5 BHK',
    rera: 'P02400005390',
    units: ' 462 Units',
    highlights: [
      '3 different Club Houses',
      '78% Open Space',
      'Best in class Architect and consultants',
      'No flats, Balcony facing each other, Complete Privacy',
    ],
    status: '',
    link: '/projects/trilight',
  },
  {
    title: 'Skyline',
    image: 'https://dprstorage.b-cdn.net/RW/candeur.png',
    sqft: '6,520 - 11,999 sq.ft',
    isReverse: true,
    bhk: '4 BHK',
    location: ' Financial District, Hyderabad',
    rera: 'P02400005670',
    units: '230 units',
    highlights: [
      'One of The Tallest residential tower in South India ',
      '13 ft ceiling height',
      'Private lift lobby for each apartment',
      'Ultra-premium clubhouse with curated luxury amenities',
    ],
    status: 'Under construction',
    link: '/projects/skyline',
  },
  {
    title: 'Songs of the Sun',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/songs%20of%20sun.png',
    sqft: '2825 - 3295 sq.ft',
    location: 'Financial District , Hyderabad',
    bhk: '3 & 4 BHK',
    rera: 'P01100007254',
    units: ' 593 Units',
    highlights: [
      'Four 37-floor towers with 592 residences',
      'Corner units for natural light and privacy',
      'G+4 clubhouse with indoor courts, co-working space, meditation zones',
      'Luxury finishes and smart design',
    ],
    status: 'Under construction',
    link: '/projects/songs-of-the-sun',
  },

  {
    title: 'Rise With 9',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/rise%20with%209.png',
    sqft: '3303 - 5777 sq.ft',
    location: ' Neopolis, Hyderabad',
    bhk: '3 & 4 BHK',
    rera: 'P02400009942',
    units: ' 370 Units',
    highlights: [
      'Twin Iconic Towers rising up to 56+ floors',
      'One of the most unique highlights is the 23-ft. double-height living area',
      '2 Iconic Residential Towers',
      'A premium multi-level clubhouse integrated within the towers',
    ],
    status: 'Under construction',
    link: '/projects/rise-with-9',
  },
  {
    title: 'Bayleaf ',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/bayleaf.png',
    sqft: '1695 - 2595 sq.ft',
    location: 'Manchirevula , Hyderabad',
    bhk: '3 & 4 BHK',
    rera: 'P02400008117',
    units: ' 200 Units',
    highlights: [
      "Premium 3 & 4 BHK expertly planned apartments",
      "Designed for families valuing open views and thoughtful living spaces",
      "Quality construction with modern finishes and lifestyle amenities",
      "Strategically located in Narsingi with timely project delivery"
    ],
    status: 'Under construction',
    link: '/projects/bayleaf',
  },
  {
    title: 'Yula Globus',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/yula.png',
    sqft: '2300 - 4500 sq.ft',
    location: 'Neopolis,  Kokapet, hyderabad',
    bhk: '3 & 4 BHK',
    rera: 'P02400010006',
    units: ' 655+ Units',
    highlights: [
      "Premium 3 & 4 BHK luxury apartments in Neopolis, Kokapet",
      "Two iconic high-rise towers with up to 57+ floors offering panoramic views",
      "Spread across ~4.36 acres with world-class amenities like clubhouse, pool & landscaped gardens",
      "Excellent connectivity to IT hubs, schools, hospitals and major roads in Hyderabad"
    ],
    status: 'Under construction',
    link: '/projects/yulaglobus',
  },
  // {
  //   title: ' Vamsiram Newmark',
  //   image: "https://dprstorage.b-cdn.net/RW/vamsiram.png",
  //   location: 'Narsingi',
  //   sqft: '4,595 – 6,500 sq.ft',
  //   bhk: '4 BHK',
  //   rera: 'P02400007343',
  //   units: '272 units ',
  //   highlights: [
  //     'Two luxury towers with 272 residences',
  //     '50,000+ sq.ft. clubhouse with rooftop lounge',
  //     'Infinity pool, pet zone, gallery, art spaces',
  //     '80% open space with greenery',
  //   ],
  //   status: ': Under construction ',

  // },


  // {
  //   title: ' The Marquise ',
  //   image: 'https://dprstorage.b-cdn.net/RW/projects/marquise.jpg',
  //   sqft: '5185.00 - 9765.00 sq.ft',
  //   location: ' Kokapet',
  //   bhk: ' 4 & 5 BHK',
  //   rera: 'P02400006708',
  //   units: '  295 Units',
  //   highlights: [
  //     'Luxury Living by the Lake @ Kokapet',
  //     'Exclusive Living: Only 2-4 Flats Per floor, Private lifts for each flat, 6 Levels of Parking',
  //     'Best-in-class amenities spread across 5 floors for leisure, entertainment',
  //     'Covered landscape spread across 87000 Sft. (Approx. 2 Acres) with recreation spaces',
  //   ],
  //   status: '',
  // },
  {
    title: 'Sage',
    image: 'https://dprstorage.b-cdn.net/RW/projects/sage.png',
    sqft: '3015 - 3600 sq.ft',
    location: 'Kollur , Hyderabad',
    bhk: '4 BHK Villas',
    rera: 'P01100008686',
    units: ' 169 Units',
    highlights: [
      'Independent villas with private garden decks',
      'Wide avenue roads & landscaped parks',
      'Clubhouse with pool, gym and indoor games',
      'EV charging readiness & solar-powered common areas',
    ],
    status: '',
    link: '/projects/sage',
  },

  {
    title: 'Bridge Epsilon',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/bridge.png',
    sqft: '6105 - 6175 sq.ft',
    location: 'Tukkuguda, Hyderabad',
    bhk: '4 BHK Villa',
    rera: 'P02400009348',
    units: '128 Unitss',
    highlights: [
      'Villa-only community with private garden parcels',
      'Wide internal roads & abundant open green pockets',
      'Resort-style clubhouse with pool & wellness studio',
      'High-spec windows for acoustic & thermal comfort',
    ],
    status: '',
    link: '/projects/bridge-epsilon',

  },
  {
    title: 'Allura',
    image: 'https://dprstorage.b-cdn.net/RW/projects/northstar.png',
    sqft: '4019 - 4910 sq.ft',
    location: 'Kokapet, Hyderabad',
    bhk: '4 BHK Luxury Villa',
    rera: 'P02400006130',
    units: '54 Units',
    highlights: [
      'Innovative Concept - Each Villa with two road access',
      'Surrounded by major MNCs and IT Companies',
      'Imported Italian marble & bath fixtures',
      'Fully-loaded clubhouse with an indoor badminton court, gym, party hall & swimming pool',
    ],
    status: '',
    link: '/projects/northstar-allura',

  },
  {
    title: 'Luxury Park II',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/luxurypark%20(1).png',
    sqft: '2025 - 2250 sq.ft',
    location: 'Mamidipally, Hyderabad',
    bhk: '4 BHK Luxury Villa',
    rera: 'P02400003294',
    units: '111 Units',
    highlights: [
      "Premium 4 BHK luxury villas in a gated community near Hyderabad International Airport",
      "HMDA & RERA approved project with contemporary architecture and high-quality finishes",
      "Wide range of world-class amenities including clubhouse, pool, gym and landscaped spaces",
      "Excellent connectivity to key routes like ORR, Srisailam Highway and major employment hubs"
    ],
    status: '',
    link: '/projects/sreenidhi-luxury-park',

  },


  {
    title: 'ONE OAK',
    image: 'https://dprstorage.b-cdn.net/RW/projects/oneoak.png',
    sqft: '6,000- 7,800 sq.ft',
    location: 'Manchirevula, Hyderabad',
    bhk: '3/4 BHK Villas',
    rera: '',
    units: '',
    highlights: [
      'Limited-edition villas in a low-density enclave',
      'Private terraces & garden decks for enach villa',
      'Premium modular kitchen with built-in appliances',
      'Gated community with curated concierge services',
    ],
    status: '',
  },
  {
    title: 'The Twins',
    image: 'https://dprstorage.b-cdn.net/RW/projects/twins.jpg',
    sqft: '15999 sq.ft',
    location: 'Puppalaguda, Hyderabad',
    bhk: '6',
    rera: 'P02400005887',
    units: '85 Units',
    highlights: [
      'Iconic twin-tower silhouette with panoramic views',
      'Private lift lobbies & limited residences per floor',
      'Sky amenities with lounge, fitness & viewing decks',
      'Curated hospitality-style arrival experience',
    ],
    status: '',
    link: '/projects/twins',
  },


  // {
  //   title: 'Nestmarkers',
  //   image: 'https://dprstorage.b-cdn.net/RW/newprojects/nestmarkers.png',
  //   sqft: '3140 - 10000 sq.ft',
  //   location: 'Tukkuguda',
  //   bhk: '4 BHK Luxury Villas',
  //   rera: '',
  //   units: '220 Units',
  //   highlights: [
  //     'Villas that are truly customizable, a first in Hyderabad',
  //     'The property boasts a 450-acre oxygen factory, creating its own microclimate',
  //     'Amenities include organic farming, pet grooming facilities, a barbecue area, a theme park, and a mini theatre',
  //   ],
  //   status: '',
  // },
  {
    title: 'Ankura Homes',
    image: "https://dprstorage.b-cdn.net/RW/newprojects/ankura.png",
    sqft: '5100 -5650 sq.ft',
    location: 'Shankarpally , Hyderabad',
    bhk: '4,5 BHK',
    rera: 'P01100008925',
    units: '104 Villas',
    // highlights: [],
    highlights: [
      'Contemporary villa architecture with clean lines',
      'Central park & kids’ play courts within the community',
      'Curated interiors with premium bath & kitchen fittings',
      '24x7 security, access control & community app',
    ],
    status: '',
  },

  {
    title: 'Som Boulevard',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/Som%20Boulevard.png',
    sqft: '2,700 - 4,275 sq.ft',
    location: 'Mokila , Hyderabad',
    bhk: '4BHK Duplex Luxury Villas',
    rera: 'P02400003701',
    units: '270 Villas',
    // highlights: [],
    highlights: [
      'Duplex villas with double-height living spaces',
      'Terrace sit-outs & private green pockets',
      'Comprehensive clubhouse & sports facilities',
      'Community retail & everyday convenience zones',
    ],
    status: '',
  },
  {
    title: 'Cascades',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/Cascades.png',
    sqft: '2560 - 4825 sq.ft',
    location: 'Kokapet , Hyderabad',
    bhk: '3,4 BHK Villas',
    rera: 'P02400009538',
    units: '1199 Units',

    highlights: [
      'Low-rise villa community with cascading landscape courts',
      'Amenity-rich clubhouse with indoor/outdoor sport zones',
      'Premium specifications with modular kitchens',
      'Multi-layer security & visitor management',
    ],

    status: '',
    link: '/projects/thecascades',
  },
   {
    title: 'Bliss in the Woods',
    image: 'https://dprstorage.b-cdn.net/RW/newprojects/nestmarkers.png',
    sqft: '2560 - 4825 sq.ft',
    location: 'Kokapet',
    bhk: '3,4 BHK Villas', 
    rera: 'P02400009538',
    units: '1199 Units',

    highlights: [
      'Luxury villas nestled amid dense natural greenery',
      'Resort-style clubhouse with premium lifestyle amenities',
      'Low-density gated community ensuring privacy and peace',
      'Excellent connectivity near ORR and airport access',
    ],

    status: '',
    link: '/projects/blissinthewoods',
  },

     {
    title: 'Mirai Mist',
    image: 'https://dprstorage.b-cdn.net/RW/projects/miraimist/mirai.png',
    sqft: '7972 - 10726 sq.ft',
    location: 'Gandipet, Hyderabad',
    bhk: '5 BHK Villas', 
    rera: 'P02400009462',
    units: '24 premium villas',

    highlights: [
      'Limited-edition ultra-luxury villas in a gated enclave',
      'Expansive layouts designed for elite, high-net-worth homeowners',
      'Seamless blend of modern architecture + natural surroundings',
      'Designed for privacy, scale, and exclusivity',
    ],

    status: '',
    link: '/projects/mirai-mist',
  },

].sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }));
